export default __webpack_public_path__ + "04ee5d0407096166c3a77c777ae4cc90.png";